{
  "id": "heimdall",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Heimdall",
    "en": "Heimdall"
  },
  "icon": "gods/heimdall",
  "portrait": "gods/heimdall-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "einheri": 1
  },
  "unlocks": ["einheri", "gjallarhorn", "safeguard", "rigsthula"],
  "powers": ["undermine"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Loki. Focus: buildings. Age tech ClassicalAgeHeimdall."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ClassicalAgeHeimdall: CreateUnit einheri quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
